import _merge from 'lodash/merge';
import EventBus from '@/event-bus';
import _Singleton from '@/tools/singleton';
import Shop from '@/shop';
import createStore from '@/storage';
import domReady from '@/tools/domReady';
import ajax from '@/ajax/checkout';
import cloneDeep from 'lodash/cloneDeep';

const currency = Shop.config.config.currency_code;
const Store = createStore({ name: 'quick-checkout-' + currency });

/**
 * Обработчик для "Заказа в один клик"
 * @class
 * @alias quickCheckout
 *
 * @private
 */
var QuickCheckout = function () {
  var self = this;

  domReady(function () {
    self._bindEvents();
  });

  return;
};

/**
 * Прибиваем слушателей шины
 * @method
 * @private
 *
 * @listens add_checkout:insales:cart
 */
QuickCheckout.prototype._bindEvents = function () {
  var self = this;

  EventBus.subscribe('add_checkout:insales:cart', function (data) {
    self.ajaxSend(data);
  });

  return;
};

/**
 * Прибиваем слушателей шины
 * @method
 * @private
 *
 * @listens add_checkout:insales:cart
 */
QuickCheckout.prototype.ajaxSend = function (data) {
  var self = this;
  var formData = data.action.formData;

  EventBus.publish('before:insales:quick_checkout', formData);

  ajax.quick(formData.ajaxParams)
    .done(function (response) {
      _merge(formData.task, response);
      self.successResponse(formData.task);
    })
    .fail(function (response) {
      _merge(formData.task, response);
      self.errorsResponse(formData.task);
    })
    .always(function () {
      EventBus.publish('always:insales:quick_checkout', formData.task);
    });

  return;
};

/**
 * Отрабатываем случай, что у нас все ок
 * @method
 * @private
 *
 * @fires success:insales:quick_checkout
 */
QuickCheckout.prototype.successResponse = function(task) {
  Store.setItem('quick-checkout', null);
  const cart = cloneDeep(window.InsalesCommonCart);

  if (!task.withoutCart) {
    window.InsalesCommonCart.clear();
  }

  EventBus.publish('success:insales:quick_checkout', { task: task, cart: cart });

  return;
};

/**
 * При отправки формы пришли ошибки
 * @method
 * @private
 *
 * @fires errors:insales:quick_checkout
 */
QuickCheckout.prototype.errorsResponse = function (task) {
  EventBus.publish('errors:insales:quick_checkout', task);

  return;
};

export default _Singleton(QuickCheckout).getInstance();
